
"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { type ThemeProviderProps } from "next-themes/dist/types"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  // Wrap the children in a React fragment to provide proper React context
  return (
    <NextThemesProvider {...props}>
      {children}
    </NextThemesProvider>
  )
}
